import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';

export const logoutOperation = async (
  setLoading: (loading: boolean) => void,
): Promise<boolean> => {
  try {
    setLoading(true);
    await appApi.logout();
    localStorage.clear();
    sessionStorage.clear();

    toast.success('התנתקת בהצלחה');

    // Redirect to login
    window.location.href = '/login';
    return true;
  } catch (e) {
    console.error(`logoutOperation failed with the error: ${e}`);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    return false;
  } finally {
    setLoading(false);
  }
};
